/*eslint-disable*/
import Trainer from '../../config/trainer.json';
import _ from 'lodash';

export default {
    methods: {
        abbreviatedValueOfSetting (setting) {
            return setting
                ? this.$i18n.t('trainer.trainer_gameFormSettingValue_onAbbreviated')
                : this.$i18n.t('trainer.trainer_gameFormSettingValue_offAbbreviated');
        },
        rulesArrayToString(array) {
            if (array.length > 0) {
                return array.join(', ');
            } else {
                return null;
            }
        },
        getGameName(game) {
            if (game) {
                let gameConfig = (_.find(Trainer.games, {slug: game.slug}) || _.find(Trainer.games, {slug: game.game}));
                game.name = gameConfig ? this.$i18n.t(gameConfig.label) : this.$root.$t('trainer.trainer_utils_gameNotFound');
                return game.name;
            }
            return null;
        },
        removeGame(index) {
            if (this.form) {
                this.form.games.splice(index, 1);
            } else {
                this.courseCopy.games.splice(index, 1);
            }
        },
        moveGame(index, direction) {
            if(direction === 'up') {
                if (index === 0) {
                    return;
                } else {
                    let origin = this.form.games[index];
                    this.form.games[index] = this.form.games[index - 1];
                    this.$set(this.form.games, index - 1, origin);
                }
            } else {
                if (index === this.form.games.length - 1) {
                    return;
                } else {
                    let origin = this.form.games[index];
                    this.form.games[index] = this.form.games[index + 1];
                    this.$set(this.form.games, index + 1, origin);
                }
            }
        },
    }
}
